import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext.tsx";
import { ThemeProvider } from "./context/ThemeContext";
import Header from "./components/Header.tsx";
import Footer from "./components/Footer.tsx";
import DashboardPage from "./pages/DashboardPage";
import ConnectionsPage from "./pages/ConnectionsPage.tsx";
import MarketplaceDemoPage from "./pages/MarketplaceDemoPage.tsx";
import DevelopersPage from "./pages/DevelopersPage";
import ProfilePage from "./pages/ProfilePage.tsx";
import ReceiptEvidencePage from "./pages/ReceiptEvidencePage";
import TrustChecksPage from "./pages/TrustChecksPage";
import { SpeedInsights } from "@vercel/speed-insights/react";
import { Analytics } from "@vercel/analytics/react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";

const App: React.FC = () => (
  <Router>
    <ThemeProvider>
      <AuthProvider>
        <div className="handle-app">
          <SpeedInsights />
          <Analytics />
          <Header />
          <div className="handle-app-content">
            <Routes>
              <Route path="/" element={<DashboardPage />} />
              <Route path="/connections" element={<ConnectionsPage />} />
              <Route path="/evidence" element={<ReceiptEvidencePage />} />
              <Route path="/trust" element={<TrustChecksPage />} />
              <Route path="/marketplace" element={<MarketplaceDemoPage />} />
              <Route path="/developers" element={<DevelopersPage />} />
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="*" element={<DashboardPage />} />
            </Routes>
          </div>
          <Footer />
        </div>
      </AuthProvider>
    </ThemeProvider>
  </Router>
);

export default App;
